import { useMutation } from "@tanstack/react-query";
import {
  apiDelete,
  getApiUrl,
  type FetchResponse,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type MutationParams = {
  channelId: string;
  memberIdentityUserPublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

const deleteChatChannelMember = (
  channelId: string,
  memberIdentityUserPublicID: string,
) =>
  apiDelete<FetchResponse<void, 200>>(
    `${getApiUrl()}/api/Chat/channel/${channelId}/members/${memberIdentityUserPublicID}`,
    undefined,
  );

export const useRemoveChatChannelMemberMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ channelId, memberIdentityUserPublicID }: MutationParams) =>
        deleteChatChannelMember(channelId, memberIdentityUserPublicID),
    ),
    onSuccess,
    onError,
  });
